import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  mealList: [],
  mealCount: 0,
};

export default function forgotPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SEND_OTP_SUCCESS_ACTION:
      return {
        ...state,
        otpSent: true,
      };

    case actionTypes.VERIFY_OTP_SUCCESS_ACTION:
      if (action.payload.ok === true) {
        return {
          ...state,
          otpVerified: true,
        };
      } else {
        return {
          ...state,
        };
      }
    case actionTypes.SET_NEW_PWD_SUCCESS_ACTION:
      return {
        ...state,
        pwdreset: true,
      };

    case actionTypes.REDIRECT_SUCCESS_ACTION:
      return {
        ...state,
        //redirecttoPage:true,
        otpSent: undefined,
        otpVerified: undefined,
        pwdreset: undefined,
      };

    default:
      return {
        ...state,
      };
  }
}
